// import React, { useEffect, useState } from "react";
// import { Modal } from "antd";
// import { useTranslation } from "react-i18next";
// import { formatDateByLang } from "../../components/function/formatDate";
// import { formatDateTimeByLang } from "../../components/function/formatDateTimeByLang";

// function useIsDark() {
//   const [isDark, setIsDark] = useState(
//     typeof document !== "undefined" &&
//     document.documentElement.classList.contains("dark")
//   );

//   useEffect(() => {
//     if (typeof document === "undefined") return;
//     const el = document.documentElement;
//     const obs = new MutationObserver(() => {
//       setIsDark(el.classList.contains("dark"));
//     });
//     obs.observe(el, { attributes: true, attributeFilter: ["class"] });
//     return () => obs.disconnect();
//   }, []);

//   return isDark;
// }

// const LicenseHistoryModal = ({ isOpen, onClose, data }) => {
//   const { i18n, t } = useTranslation();
//   const isDark = useIsDark();

//   if (!data) return null;

//   return (
//     <Modal
//       open={isOpen}
//       onCancel={onClose}
//       footer={null}
//       centered
//       closeIcon={
//         <span
//           style={{
//             color: isDark ? "#ffffff" : "#111827",
//             fontSize: 18,
//             lineHeight: 1,
//           }}
//         >
//          ✕
//         </span>
//       }
//       styles={{
//         header: { background: isDark ? "#111827" : "#ffffff" },
//         content: { background: isDark ? "#111827" : "#ffffff" },
//         body: { color: isDark ? "#ffffff" : "#111827" }, // ✅ yazılar
//         closeButton: { color: isDark ? "#ffffff" : "#111827" }, // ✅ X
//       }}
//       title={
//         <span className="text-xl font-semibold text-gray-900 dark:!text-white transition-colors">
//           {t("License History")}
//         </span>
//       }
//       className="
//         [&_.ant-modal-content]:transition-colors
//         [&_.ant-modal-content]:duration-300 

//         [&_.ant-modal-header]:bg-white
//         dark:[&_.ant-modal-header]:bg-gray-900
//         [&_.ant-modal-content]:bg-white
//         dark:[&_.ant-modal-content]:bg-gray-900

//         /* ✅ Dark modda modal içindeki HER ŞEY beyaz */
//         dark:[&_.ant-modal-body_*]:!text-white
//         dark:[&_.ant-modal-title]:!text-white

//         /* ✅ X rengi + hover halkası kapalı */
//         [&_.ant-modal-close]:!text-gray-900
//         dark:[&_.ant-modal-close]:!text-white
//         [&_.ant-modal-close-x]:!text-gray-900
//         dark:[&_.ant-modal-close-x]:!text-white
//         [&_.ant-modal-close:hover]:bg-transparent
//         [&_.ant-modal-close:focus]:bg-transparent
//         [&_.ant-modal-close:active]:bg-transparent
//         [&_.ant-modal-close:focus-visible]:bg-transparent
//         [&_.ant-modal-close]:shadow-none
//         [&_.ant-modal-close]:outline-none
//         [&_.ant-modal-close:focus-visible]:outline-none
//       "
//     >
//       <div className="transition-colors duration-300 text-gray-900 dark:!text-white">
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-sm border border-gray-300 dark:border-gray-600">
//             <tbody>
//               <tr>
//                 <td className="px-3 py-2 font-semibold border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {t("License ID")}
//                 </td>
//                 <td className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {data.id ?? "-"}       
//                 </td>
//               </tr>

//               <tr>
//                 <td className="px-3 py-2 font-semibold border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {t("User Generated")}
//                 </td>
//                 <td className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {data.createdBy ?? "-"}
//                 </td>
//               </tr>

//               <tr>
//                 <td className="px-3 py-2 font-semibold border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {t("Date Generated")}
//                 </td>
//                 <td className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {data.createdAt
//                     ? formatDateByLang(data.createdAt, i18n.language)
//                     : "-"}
//                 </td>
//               </tr>

//               <tr>
//                 <td className="px-3 py-2 font-semibold border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {t("Last Update User")}
//                 </td>
//                 <td className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {data.modifiedBy ?? "-"}
//                 </td>
//               </tr>

//               <tr>
//                 <td className="px-3 py-2 font-semibold border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {t("Last Update Date")}
//                 </td>
//                 <td className="px-3 py-2 border border-gray-300 dark:border-gray-600 text-gray-900 dark:!text-white">
//                   {data.modifiedAt
//                     ? formatDateTimeByLang(data.modifiedAt, i18n.language)
//                     : "-"}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </Modal>

//   );
// };

// export default LicenseHistoryModal;

// import React, { useMemo } from "react";
// import { Modal } from "antd";
// import { useTranslation } from "react-i18next";
// import { formatDateByLang } from "../../components/function/formatDate";
// import { formatDateTimeByLang } from "../../components/function/formatDateTimeByLang";

// const LicenseHistoryModal = ({ isOpen, onClose, data }) => {
//   const { t, i18n } = useTranslation();

//   const rows = useMemo(
//     () => [
//       { k: t("License ID"), v: data?.id ?? "-" },
//       { k: t("User Generated"), v: data?.createdBy ?? "-" },
//       {
//         k: t("Date Generated"),
//         v: data?.createdAt ? formatDateByLang(data.createdAt, i18n.language) : "-",
//       },
//       { k: t("Last Update User"), v: data?.modifiedBy ?? "-" },
//       {
//         k: t("Last Update Date"),
//         v: data?.modifiedAt
//           ? formatDateTimeByLang(data.modifiedAt, i18n.language)
//           : "-",
//       },
//     ],
//     [data, i18n.language, t]
//   );

//   return (
//     <Modal
//       open={isOpen}
//       onCancel={onClose}
//       footer={null}
//       centered
//       destroyOnClose
//       closeIcon={
//         <span className="text-gray-900 dark:text-white text-xl leading-none">✕</span>
//       }
//       styles={{
//         header: { background: "transparent" },
//         content: { background: "transparent" },
//         body: { background: "transparent" },
//       }}
//       className="
//         /* Modal container - belirgin çerçeve */
//         [&_.ant-modal-content]:!p-0
//         [&_.ant-modal-content]:!rounded-2xl
//         [&_.ant-modal-content]:!border
//         [&_.ant-modal-content]:!border-gray-300
//         [&_.ant-modal-content]:!shadow-2xl
//         [&_.ant-modal-content]:!bg-white

//         dark:[&_.ant-modal-content]:!bg-[#151515]
//         dark:[&_.ant-modal-content]:!border-white/25

//         /* Padding + başlık-table mesafesi kısa */
//         [&_.ant-modal-header]:!p-3
//         [&_.ant-modal-body]:!pt-2
//         [&_.ant-modal-body]:!px-3
//         [&_.ant-modal-body]:!pb-3

//         /* Title center (AntD title alanı tam ortalanır) */
//         [&_.ant-modal-title]:!w-full
//         [&_.ant-modal-title]:!text-center

//         /* X renkleri */
//         [&_.ant-modal-close]:!text-gray-900
//         dark:[&_.ant-modal-close]:!text-white
//         [&_.ant-modal-close-x]:!text-gray-900
//         dark:[&_.ant-modal-close-x]:!text-white

//         /* Dark: içerideki yazılar beyaz */
//         dark:[&_.ant-modal-body_*]:!text-white
//       "
//       title={
//         <div className="w-full text-center">
//           <span className="text-lg font-semibold text-gray-900 dark:text-white">
//             {t("License History")}
//           </span>
//         </div>
//       }
//     >
//       <div className="overflow-x-auto">
//         <table
//           className="
//             min-w-full text-sm
//             border border-gray-300
//             rounded-xl overflow-hidden

//             dark:border-white/25
//           "
//         >
//           <tbody>
//             {rows.map((r, idx) => {
//               const isEven = idx % 2 === 0;

//               return (
//                 <tr
//                   key={idx}
//                   className={`
//                     border-b last:border-b-0
//                     border-gray-300 dark:border-white/20
//                     transition-colors

//                     /* Light zebra */
//                     ${isEven ? "bg-gray-100" : "bg-white"}
//                     hover:bg-gray-200

//                     /* Dark zebra */
//                     dark:${isEven ? "bg-[#1E1E1E]" : "bg-[#242424]"}
//                     dark:hover:bg-[#2C2C2C]
//                   `}
//                 >
//                   <td
//                     className="
//                       w-[220px] px-4 py-3 align-top font-semibold
//                       text-gray-900 dark:!text-white
//                       border-r border-gray-300 dark:border-white/20
//                       whitespace-nowrap
//                     "
//                   >
//                     {r.k}
//                   </td>

//                   <td className="px-4 py-3 text-gray-900 dark:!text-white break-words">
//                     {r.v}
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </Modal>
//   );
// };

// export default LicenseHistoryModal;

import React, { useMemo } from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { formatDateByLang } from "../../components/function/formatDate";
import { formatDateTimeByLang } from "../../components/function/formatDateTimeByLang";

const LicenseHistoryModal = ({ isOpen, onClose, data }) => {
  const { t, i18n } = useTranslation();

  const htmlHasDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");

  const isDark = htmlHasDark;

  // ✅ Light/Dark tema
  const theme = isDark
    ? {
        // DARK
        mask: "rgba(0,0,0,0.70)",
        modalBg: "#111827", // gray-900 (koyu arkaplan)
        titleColor: "#ffffff",
        closeColor: "#ffffff",

        // tablo tek ton: mevcut olandan daha koyu gri
        tableBg: "#74151", // gray-700 
        border: "#ffffff", // iç çizgiler beyaz
        borderStrong: "#ffffff", // dış çizgi beyaz
        cellText: "#ffffff",
        labelText: "#ffffff",
      }
    : {
        // LIGHT
        mask: "rgba(0,0,0,0.35)",
        modalBg: "#ffffff",
        titleColor: "#111827", // gray-900
        closeColor: "#111827",

        // bg-gray-200 tonuna paralel
        tableBg: "#74151", // gray-200
        border: "#9ca3af", // gray-400 (iç çizgi daha belirgin)
        borderStrong: "#6b7280", // gray-500 (dış çizgi daha belirgin)
        cellText: "#111827",
        labelText: "#111827",
      };

  const rows = [
    { label: t("License ID"), value: data?.id ?? "-" },
    { label: t("User Generated"), value: data?.createdBy ?? "-" },
    {
      label: t("Date Generated"),
      value: data?.createdAt ? formatDateByLang(data.createdAt, i18n.language) : "-",
    },
    { label: t("Last Update User"), value: data?.modifiedBy ?? "-" },
    {
      label: t("Last Update Date"),
      value: data?.modifiedAt
        ? formatDateTimeByLang(data.modifiedAt, i18n.language)
        : "-",
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={560}
      closeIcon={
        <span
          style={{
            color: theme.closeColor,
            fontSize: 18,
            lineHeight: 1,
          }}
        >
          ✕
        </span>
      }
      styles={{
        mask: { backgroundColor: theme.mask },

        header: {
          background: theme.modalBg,
          borderBottom: "0px",
          paddingBottom: 4, // ✅ başlık-tablo arası daha yakın
        },

        content: {
          background: theme.modalBg,

          // ✅ keskin köşe
          borderRadius: 0,

          // ✅ dış border belirgin
          border: `2px solid ${theme.borderStrong}`,
          overflow: "hidden",
        },

        body: {
          background: theme.modalBg,
          paddingTop: 6, // ✅ başlık-tablo arası yakın
        },
      }}
      title={
        <div
          style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: 20,
            color: theme.titleColor,
          }}
        >
          {t("License History")}
        </div>
      }
      className="
        [&_.ant-modal-title]:w-full
        [&_.ant-modal-close]:shadow-none
        [&_.ant-modal-close:hover]:bg-transparent
        [&_.ant-modal-close:focus]:bg-transparent
        [&_.ant-modal-close:active]:bg-transparent
      "
    >
      <div
        style={{
          background: theme.tableBg,
          border: `2px solid ${theme.borderStrong}`, // ✅ tablo dış border kalın
          borderRadius: 0, // ✅ keskin köşe
          overflow: "hidden",
        }}
      >
        <table
          className="w-full text-sm"
          style={{
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        >
          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx}>
                <td
                  style={{
                    width: "42%",
                    padding: "14px 16px",
                    fontWeight: 700,
                    color: theme.labelText,

                    // ✅ iç border belirgin + keskin
                    borderRight: `2px solid ${theme.borderStrong}`,
                    borderBottom: idx === rows.length - 1 ? "0px" : `2px solid ${theme.border}`,

                    background: theme.tableBg,
                  }}
                >
                  {r.label}
                </td>

                <td
                  style={{
                    padding: "14px 16px",
                    color: theme.cellText,
                    borderBottom: idx === rows.length - 1 ? "0px" : `2px solid ${theme.border}`,
                    background: theme.tableBg,
                    wordBreak: "break-word",
                  }}
                >
                  {r.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default LicenseHistoryModal;


